import { findProjectDesignationOption, getProjectDesignationLabel } from "../../Hooks/useProjectDesignationOptions.js";

export function getDesignationDisplayLabel(code: string | undefined | null): string {
  return getProjectDesignationLabel(code);
}

/** Keep the designation's location in its own column when a table shows both. */
export function getDesignationName(code: string | undefined | null): string {
  if (!code) return "Not set";
  const label = getDesignationDisplayLabel(code).replace(/\s*\((?:Onshore|Offshore)\)\s*$/i, "").trim();
  if (label !== label.toUpperCase()) return label;
  const acronyms = new Set(["BA", "QA", "RPA", "CPQ", "FSC", "PM", "EDI", "IDP"]);
  return label.toLowerCase().split(/\s+/).map((word) => {
    const upper = word.toUpperCase();
    if (acronyms.has(upper)) return upper;
    if (upper === "MULESOFT") return "MuleSoft";
    if (upper === "SALESFORCE") return "Salesforce";
    return word[0].toUpperCase() + word.slice(1);
  }).join(" ");
}

export function getDesignationTypeLabel(code: string | undefined | null, locationType?: string | null): string {
  const type = locationType || findProjectDesignationOption(code)?.locationType
    || String(code ?? "").match(/(?:_|\s|\()((?:ON|OFF)SHORE)\)?$/i)?.[1];
  return type?.toUpperCase() === "ONSHORE" ? "Onshore" : type?.toUpperCase() === "OFFSHORE" ? "Offshore" : "—";
}
